'use client';

import Script from 'next/script';

export function Scripts({}: { isProduction: boolean }) {
  return (
    <>
      <Script
        type='application/javascript'
        strategy='afterInteractive'
        src='//www.googletagmanager.com/gtag/js?id=G-VK9B18XKCK'
      ></Script>

      <Script
        type='application/javascript'
        strategy='afterInteractive'
        data-domain='bb-escort.de'
        src='//stats.skypleasureltd.com/js/script.js'
      ></Script>

      <Script id='gtag-init' strategy='afterInteractive'>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());

          gtag('config', 'G-VK9B18XKCK');
        `}
      </Script>
    </>
  );
}
